import { render, staticRenderFns } from "./OpenInventoryRequest.vue?vue&type=template&id=ef613868&scoped=true&"
import script from "./OpenInventoryRequest.vue?vue&type=script&lang=js&"
export * from "./OpenInventoryRequest.vue?vue&type=script&lang=js&"
import style0 from "./OpenInventoryRequest.vue?vue&type=style&index=0&id=ef613868&prod&lang=scss&scoped=true&"
import style1 from "./OpenInventoryRequest.vue?vue&type=style&index=1&id=ef613868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef613868",
  null
  
)

export default component.exports